import { useCallback } from 'react'
import { useStore } from 'zustand'

import { EditorActionBarStoreType } from 'components/WorkspaceEditor/types/editorActionBar.type'
import { createEditorActionBarStoreContainer } from './EditorActionBarStore'
import { useEditorActionBarStoreContext } from './EditorActionBarStoreProvider'

export const useEditorActionBarStore = <U>(
    selector: (state: EditorActionBarStoreType) => U
) => {
    const {
        projectId,
        editorActionBarStores,
    } = useEditorActionBarStoreContext()

    const getEditorActionBarStore = useCallback(
        () => createEditorActionBarStoreContainer(editorActionBarStores),
        [editorActionBarStores]
    )

    return useStore(getEditorActionBarStore()(projectId), selector)
}
